import type { TariffDraft } from '../api';

/**
 * The starter shape, for a firm that has never priced anything.
 *
 * In the firm's own currency. It used to say BGN, so a firm provisioned in euros opened its
 * very first tariff in leva, and an administrator who did not notice priced every ride in a
 * currency the firm does not use (#376). Every later tariff copies the one in force, so the
 * first is the only one this decides — and it is the one that matters.
 */
export function blankTariff(currency: string): TariffDraft {
  return {
    code: 'standard',
    displayName: 'Standard',
    vehicleCategoryCode: null,
    effectiveFrom: null,
    baseFare: 0,
    perKilometre: 0,
    perMinute: 0,
    perWaitingMinute: 0,
    freeWaitingMinutes: 3,
    minimumFare: 0,
    currency,
    roundingIncrement: 0.01,
  };
}
